import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["zoneSelect", "levelOnlyCheckbox"]

  zoneSelected(event) {
    if (event.target.value === "") return

    const selectId = event.target.id
    if (selectId.includes("district")) {
      this.uncheckCheckboxById("state_level_only")
    } else if (selectId.includes("school")) {
      this.uncheckCheckboxById("state_level_only")
      this.uncheckCheckboxById("district_level_only")
    }
  }

  levelOnlyChanged(event) {
    if (!event.target.checked) return

    const checkboxId = event.target.id
    if (checkboxId.includes("state_level_only")) {
      this.clearSelectById("district")
      this.clearSelectById("school")
    } else if (checkboxId.includes("district_level_only")) {
      this.clearSelectById("school")
    }
  }

  audienceTypeChanged(event) {
    if (event.target.value !== "open_session") return

    this.zoneSelectTargets.forEach(select => this.clearSelect(select))
    this.levelOnlyCheckboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
  }

  uncheckCheckboxById(idSuffix) {
    this.levelOnlyCheckboxTargets.forEach(checkbox => {
      if (checkbox.id.includes(idSuffix)) {
        checkbox.checked = false
      }
    })
  }

  clearSelectById(idPart) {
    this.zoneSelectTargets.forEach(select => {
      if (select.id.includes(idPart)) {
        this.clearSelect(select)
      }
    })
  }

  clearSelect(select) {
    let promptOption = Array.from(select.options).find(o => o.value === "")
    if (!promptOption) {
      promptOption = new Option("Select", "")
      select.insertBefore(promptOption, select.firstChild)
    }
    select.value = ""
  }
}
